"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.brandReducer = exports.brandAction = exports.brandTypes = void 0;
const brand_component_1 = __importDefault(require("./sub-components/brand.component"));
const brand_action_1 = __importDefault(require("./brand.action"));
exports.brandAction = brand_action_1.default;
const brand_reducer_1 = __importDefault(require("./brand.reducer"));
exports.brandReducer = brand_reducer_1.default;
const brand_types_1 = require("./brand.types");
Object.defineProperty(exports, "brandTypes", { enumerable: true, get: function () { return brand_types_1.brandTypes; } });
exports.default = brand_component_1.default;
